const home = {
  Introduction_title: 'Giới thiệu',
  IntroductionHome1:
    'UTraffic (UTraffic: Urban Traffic Estimation System): Hệ thống dự báo tình trạng giao thông đô thị dựa vào dữ liệu từ cộng đồng',
  IntroductionHome2: 'đã nghiên cứu và đề xuất các giải pháp hợp lý,',
  IntroductionHome3: 'vận dụng sức mạnh của công nghệ 4.0',
  IntroductionHome4: 'và',
  IntroductionHome5: 'sức mạnh của cộng đồng',
  IntroductionHome6: 'nhằm giải quyết các vấn đề',
  IntroductionHome7: 'cốt lõi, mới',
  IntroductionHome8: 'và',
  IntroductionHome9: 'chưa được giải quyết tốt',
  IntroductionHome10:
    'bởi các giải pháp hiện có, góp phần giảm thiểu ùn tắt giao thông (UTGT), nâng cao sự an toàn và thuận lợi cho người tham gia giao thông. Utraffic bao gồm các giải pháp nổi bật sau: ',
  Outstanding_Solutions1:
    'Dữ liệu về giao thông được thu thập từ nhiều nguồn trong đó có nguồn quan trọng là từ cộng đồng thông qua ứng dụng trên điện thoại di động và ứng dụng web',
  Outstanding_Solutions2:
    'Ước lượng và dự báo tình trạng giao thông (TTGT) chính xác và kịp thời bằng các kỹ thuật phân tích dữ liệu lớn và học máy',
  Outstanding_Solutions3: 'Cảnh báo UTGT cho người dân một cách kịp thời',
  Outstanding_Solutions4:
    'Hỗ trợ chức năng tìm đường (routing) hiệu quả có xét đến TTGT',
  Outstanding_Solutions5:
    'Cung cấp thông tin thống kê, dự báo, hỗ trợ công tác ra quyết định của nhà quản lý.',
  Mobile_application: 'Ứng dụng trên di động (Utraffic Mobile)',
  Web_application: 'Ứng dụng trên web (Utraffic Website)',
  MIS_system:
    'Hệ thống thông tin quản lý cho Đài tiếng nói Nhân dân TP.HCM, Kênh giao thông đô thị (95.6MHz) (VoH Website)',
  Apis: 'Publish APIs and API document (Documents)',
  Feature_title: 'Đặc điểm',
  Easy_Use: 'Dễ sử dụng',
  Free: 'Miễn phí',
  Many_Utilities: 'Nhiều tiện ích',
  Product: 'Sản phẩm của HCMUT',
  Easy_Use_Description:
    'Utraffic được thiết kế nhằm cung cấp sự thuận tiện và dễ sử dụng với ứng dụng trên điện thoại di động và trên nền tảng web',
  Free_Description: 'Utraffic là miễn phí nhằm phục vụ tốt nhất cho cộng đồng',
  Product_Description:
    'UTraffic được phát triển và duy trì bởi một nhóm sinh viên và học viên cao học của trường Đại học Bách Khoa Hồ Chí Minh (HCMUT).',
  Many_Utilities_Description:
    'UTraffic cung cấp nhiều tiện ích cho cộng đồng bao gồm chia sẻ dữ liệu về TTGT, truy cập thông tin về UTGT, tìm đường đi ngắn nhất (theo không gian và theo thời gian có xét đến TTGT hiện tại,...), rút trích dữ liệu về giao thông phục vụ công tác nghiên cứu phát triển, hỗ trợ công tác xử lý, lưu trữ thông tin về giao thông tại Kênh giao thông đô thị (95.6MHz) của VoH,...',
  Software_Product_Title: 'Sản phẩm phần mềm',
  Software_Product_Description:
    'UTraffic là một hệ thống gồm các phần mềm chính sau:',
  UTrafficMobile: 'UTrafficMobile',
  UTrafficPortal: 'UTrafficPortal',
  UTrafficMIS: 'UTrafficMIS',
  PublishData_APIs_Documents: 'Publish dữ liệu, APIs và tài liệu (Documents)',
  UTrafficMobile_Description:
    'Ứng dụng trên điện thoại di động hỗ trợ thu thập dữ liệu dựa vào cộng đồng, hiển thị và cảnh báo TTGT, hỗ trợ tìm đường tối ưu,.... Người dùng có thể download miễn phí ứng dụng tại ',
  UTrafficPortal_Description:
    'Ứng dụng web thu thập, tổ chức lưu trữ và phân tích dữ liệu lớn để dự báo TTGT, UTGT,..., hỗ trợ tìm đường tối ưu. Người dùng truy xuất vào hệ thống này tại ',
  UTrafficMIS_Description1:
    'Hệ thống thông tin quản lý về TTGT đang được sử dụng thực tế  tại ',
  UTrafficMIS_Description2: 'Kênh giao thông đô thị (95,6MHz) của ',
  UTrafficMIS_Description3:
    'Đài tiếng nói Nhân dân TP.HCM (VOH), nhằm phục vụ tốt nhất cộng đồng.',
  PublishData_APIs_Documents_Description:
    ' Cung cấp cơ chế lấy dữ liệu thực tế về TTGT theo thời gian, các APIs phát triển hệ thống này cũng như các tài liệu liên quan để nhà nghiên cứu, nhà phát triển phần mềm có thể sử dụng trong nghiên cứu và phát triển. Người dùng có thể khảo sát các tiện ích này trên menu chính của trang web.',
  Members: 'Thành viên',
};
export default home;
